export default __webpack_public_path__ + "static/media/feedbackBird.6bd046f7.png";